import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SoundService {
  private sounds: Record<string, HTMLAudioElement>;

  constructor() {
    this.sounds = {
      win: new Audio('../../assets/music/success.mp3'),
      fail: new Audio('../../assets/music/fail.mp3'),
      success: new Audio('../../assets/music/success2.mp3'),
    };
  }

  async play(sound: string): Promise<void> {
    const audio = this.sounds[sound];
    console.log(audio)
    if (audio) {
      try {
        await audio.play();
      } catch (error) {
        console.error(`Error playing sound "${sound}":`, error);
      }
    } else {
      console.warn(`Sound "${sound}" does not exist.`);
    }
  }
}
